import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  defaults: '2025-05-24',
};

if (typeof window !== 'undefined') {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, options);
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </StrictMode>,
);
